import React, { useState } from "react";
import { createProviderTool } from "../../Services/Provider/providerService";
import styles from "./CreateProvider.module.css";
import Select from "react-select";
import { ProviderTypeOptions } from "../../Utils/constants";
import { useNavigate } from "react-router-dom";
import Loader from "../Loader";
import GeneralToast from "../Toaster";

const CreateProvider = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    gstnId: "",
    type: "",
    description: "",
    externalId: "",
    agriNetworkId: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage("");
    const payload = {
      input: {
        entityType: "Provider",
        entityToCreate: {
          Provider: { ...formData },
        },
      },
    };
    createProviderTool(payload)
      .then((res) => {
        setIsLoading(false);
        if (res?.data?.status === 200) {
          navigate("/provider/view");
        } else {
          setErrorMessage(
            res?.response?.data?.errorMessage ||
              res?.message ||
              "Something went wrong"
          );
        }
      })
      .catch((err) => {
        setIsLoading(false);
        setErrorMessage("Something went wrong");
      });
  };

  return (
    <>
      {isLoading && <Loader />}
      <p className="flex items-center justify-center mt-20 text-lg text-[#0e76a8]">
        <b>Add Provider</b>
      </p>
      <div style={{ maxWidth: "500px", margin: "0 auto", padding: "20px" }}>
        <form onSubmit={handleSubmit}>
          <div className={styles.formGroupStyle}>
            <label htmlFor="name" className={styles.labelStyle}>
              Name: <span className="text-red-700">*</span>
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className={styles.inputStyle}
              required
            />
          </div>

          <div className={styles.formGroupStyle}>
            <label htmlFor="type" className={styles.labelStyle}>
              Type: <span className="text-red-700">*</span>
            </label>
            <Select
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  width: 300,
                  border: `1px solid ${
                    state.isFocused ? "#0e76a8" : "#cccccc"
                  }`,
                  borderRadius: "4px",
                  boxShadow: state.isFocused
                    ? "0 0 5px rgba(14, 118, 168, 0.5)"
                    : "none",
                  transition: "border-color 0.3s ease",
                }),
                option: (baseStyles, { isFocused, isSelected }) => ({
                  ...baseStyles,
                  backgroundColor: isSelected
                    ? "#0e76a8"
                    : isFocused
                    ? "#0e76a861"
                    : "#ffffff",
                  color: isSelected ? "white" : "black",
                  padding: 10,
                }),
              }}
              defaultValue={ProviderTypeOptions.find(
                (option) => option.value === formData.type
              )}
              options={ProviderTypeOptions}
              onChange={(selectedOption) =>
                setFormData({ ...formData, type: selectedOption?.value || "" })
              }
              required
            />
          </div>

          <div className={styles.formGroupStyle}>
            <label htmlFor="description" className={styles.labelStyle}>
              Description: <span className="text-red-700">*</span>
            </label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              className={styles.inputStyle}
              required
            />
          </div>

          <div className={styles.formGroupStyle}>
            <label htmlFor="gstnId" className={styles.labelStyle}>
              GSTN ID:
            </label>
            <input
              type="text"
              id="gstnId"
              name="gstnId"
              value={formData.gstnId}
              onChange={handleChange}
              className={styles.inputStyle}
            />
          </div>

          <div className={styles.formGroupStyle}>
            <label htmlFor="externalId" className={styles.labelStyle}>
              External ID:
            </label>
            <input
              type="textr"
              id="externalId"
              name="externalId"
              value={formData.externalId}
              onChange={handleChange}
              className={styles.inputStyle}
            />
          </div>

          <div className={styles.formGroupStyle}>
            <label htmlFor="agriNetworkId" className={styles.labelStyle}>
              Agri Network ID:
            </label>
            <input
              type="text"
              id="agriNetworkId"
              name="agriNetworkId"
              value={formData.agriNetworkId}
              onChange={handleChange}
              className={styles.inputStyle}
            />
          </div>

          <button type="submit" className={styles.submit}>
            Submit
          </button>
        </form>
      </div>
      {errorMessage && <GeneralToast type="error" message={errorMessage} />}
    </>
  );
};

export default CreateProvider;
